module.exports = __webpack_public_path__ + "static/img/surface10.cc85735.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/surface10.png
// module id = fJt+
// module chunks = 2